
class CapParentOwnStudent {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_parent_own_student'
}

function create(config) {
  return new CapParentOwnStudent(config)
}

export default {
  key,
  create,
}
